export const CONSTANTS = {
  SCREEN_GROUP: 'inventory',
  LIST_ALL: 'list-inventory-all',
  LIST_INVENTORY_CLASS_LIST: 'list-inventory-class-list',
  LIST_INVENTORY_STATUS_LIST: 'list-inventory-status-list',
  LIST_INVENTORY_PRODUCT_GROUP_LIST: 'list-inventory-product-group-list',
  GRID_INVENTORY_INQUIRY: 'grid-inventory-inquiry',
  GRID_INVENTORY_ITEM_DETAIL: 'grid-inventory-item-detail',
  GRID_INVENTORY_LOT_DETAIL: 'grid-inventory-lot-detail',
} as const;
